const INVALID_DATADOG_TAG_CHARACTERS = /[^a-z0-9_./-]+/g
const INVALID_DATADOG_TAG_EDGES = /^[_./-]+|[_./-]+$/g

export function normalizeDatadogTag(
  value: string | undefined,
  fallback: string
): string {
  const normalized = (value ?? fallback)
    .trim()
    .toLowerCase()
    .replace(INVALID_DATADOG_TAG_CHARACTERS, '_')
    .replace(INVALID_DATADOG_TAG_EDGES, '')
  return normalized || fallback
}
